import swal from "@sweetalert/with-react";
import history from "../utils/history";
import { navigateToCourse } from "../utils/courseNavigation";

import { store as Store } from '../store'
import { Creators  } from '../store/ducks/newCourse/actions'

const handleRedirectMessage = mediaUrl => {
  swal({
    title: `Redirecionamento para link externo`,
    text: `O item que você selecionou encontra-se em outro local, por isso iremos lhe encaminhar para outro site em uma nova aba. Clique no botão "prosseguir" para avançar`,
    buttons: {
      confirm: {
        text: "PROSSEGUIR",
        value: true,
        visible: true,
        className: "btn-alert btn-alert-confirm-onboarding"
      },
      cancel: {
        text: "Cancelar",
        value: false,
        visible: true,
        className: "btn-alert"
      }
    }
  }).then(value => {
    if (value) {
      window.open(mediaUrl, "_blank");
    }
  });
};

const redirectToCourse = (value) => {
  const [course, object] = value.split("@");
  navigateToCourse(course, undefined, { history, object });
};

const redirectToAssessment = (value, cta) => {
  const { type, courseCrCode } = cta;
  const [course] = value.split("@");
  const redirectRoute = `${window.location.origin}/assessment-waiting-room?code=${value}&type=${type}&courseCrCode=${courseCrCode || course}`;
  window.open(redirectRoute, "__blank");
};

const redirectToLink = (value) => {
  const url = value.includes("https://") ? value : `https://${value}`;
  handleRedirectMessage(url);
};

const redirectToTenant = (value) => {
  const [tenant, course, object] = value.split("@");
  const tenancy = JSON.parse(localStorage.getItem('tenancy')) || [];
  const foundTenant = tenancy.find(item => item.tenancy === tenant);
  
  if(foundTenant) {
    const redirectData = {
      tenant: foundTenant
    }
    if(course) {
      redirectData.course = course
    }

    if(object) {
      redirectData.object = object
    }
    Store.dispatch(Creators.redirectToTenant(redirectData))
  } else {
    swal({
      title: `Atenção!`,
      text: `Você não possui acesso a esta Área de Aprendizado, por favor entre em contato com o sac@lit.com.br.`,
      buttons: {
        confirm: {
          text: "OK",
          value: true,
          visible: true,
          className: "btn-alert btn-alert-confirm-onboarding"
        }
      }
    });
  }
};

const actions = {
  "redirect_to_course": redirectToCourse,
  "redirect_to_assessment": redirectToAssessment,
  "link": redirectToLink,
  "redirect_to_tenant": redirectToTenant
};

export function openCallToAction(cta) {
  if (!cta) {
    return;
  }
  
  const { key, value } = cta;
  const execute = actions[key];
  
  if (execute) {
    if (key === "redirect_to_assessment") {
      execute(value, cta);
    } else {
      execute(value);
    }
  } else {
    console.log('cta não mapeado');
  }
}

